import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
function getSortedBreakpoints(theme, breakpoints) {
  if (breakpoints.length === 0) {
    return breakpoints;
  }
  var property = "maxWidth" in breakpoints[0] ? "maxWidth" : "minWidth";
  var sorted = _toConsumableArray(breakpoints).sort(function (a, b) {
    return theme.fn.size({
      size: b[property],
      sizes: theme.breakpoints
    }) - theme.fn.size({
      size: a[property],
      sizes: theme.breakpoints
    });
  });
  return property === "minWidth" ? sorted.reverse() : sorted;
}
export { getSortedBreakpoints };